import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import ProgressBar from './ProgressBar';
import ParametersStore from 'stores/ParametersStore';
import CargosStore from 'stores/CargosStore';
import CategoryStore from 'stores/CategoryStore';
import RouteStore from 'stores/RouteStore';
import UserStore from 'stores/UserStore';
import InstantBookingStore from 'stores/InstantBookingStore'
import ActionCreators from 'actions/ActionCreators';
import ga from 'react-ga';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import './ProgressBarPane.scss';

function getStateFromStores() {
    return {
        parameters: ParametersStore.getDeliveryParameters(),
        cargos: CargosStore.getDeliveryCargos(),
        totalWeight: CargosStore.getTotalWeight(),
        totalVolume: CargosStore.getTotalVolume(),
        selectedCategory: CategoryStore.getSelected(),
        locations: RouteStore.getLocations(),
        dates: RouteStore.getDates(),
        time: RouteStore.getTime(),
        showTips: UserStore.getShowTips(),
        showInstantBooking: InstantBookingStore.showInstantBooking(),
    }
}

class ProgressBarPane extends Component {

    static propTypes = {
        className: PropTypes.string,
        categoryId: PropTypes.string,
        linkActive: PropTypes.array,
        location: PropTypes.object,
    };

    static defaultProps = {
        linkActive: [false, false, false, false, false],
    };

    state = {
        ...getStateFromStores(),
        confirmedDescription: false,
        confirmedDimensions: false,
        confirmedParameters: false,
        confirmedLocations: false,
        confirmedDateAndTime: false
    }

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentWillMount() {
        this._checkDescription();
        this._checkDimensions();
        this._checkParameters();
        this._checkLocations();
        this._checkDateAndTime();
    }

    componentDidMount() {
        RouteStore.addChangeListener(this._onChange);
        CargosStore.addChangeListener(this._onChange);
        ParametersStore.addChangeListener(this._onChange);
        InstantBookingStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        RouteStore.removeChangeListener(this._onChange);
        CargosStore.removeChangeListener(this._onChange);
        ParametersStore.removeChangeListener(this._onChange);
        InstantBookingStore.removeChangeListener(this._onChange);
    }

    _onChange = (store) => {
        this.setState(getStateFromStores());

        this._checkDescription();
        this._checkDimensions();
        this._checkParameters();
        this._checkLocations();
        this._checkDateAndTime();
    }

    _checkValue = (attribute) => {
        if (attribute !== undefined) {
            if (attribute.value) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    _checkDescription = () => {
        if (this.state.cargos) {
            this.setState({
                confirmedDescription: this.state.cargos.size > 0
            })
        } else {
            this.setState({
                confirmedDescription: false
            })
        }
    }

    _checkDimensions = () => {
        if (this.state.totalVolume && this.state.totalVolume !== 0) {
            this.setState({
                confirmedDimensions: true
            })
        } else if (this.state.totalWeight && this.state.totalWeight !== 0) {
            this.setState({
                confirmedDimensions: true
            })
        } else {
            this.setState({
                confirmedDimensions: this._checkCargos()
            })
        }
    }

    _checkCargos = () => {
        if (this.state.cargos) {
            var allCargos = this.state.cargos.toJS().map((cargo) => {
                return cargo.attributes;
            });
            var checkDimensions = false;

            allCargos.forEach((cargo) => {
                if (this._checkValue(cargo.length) ||
                    this._checkValue(cargo.width) ||
                    this._checkValue(cargo.height) ||
                    this._checkValue(cargo.volume) ||
                    this._checkValue(cargo.weight)) {
                    checkDimensions = true;
                    return false;
                }
            });

            return checkDimensions;
        } else {
            return false;
        }
    }

    _checkParameters = () => {
        if (this.state.parameters) {
            var checkParameters = false;
            var parameters = this.state.parameters;

            for (var parameter in parameters) {
                if (parameters[parameter].name !== 'load_floor' &&
                    parameters[parameter].name !== 'unload_floor' &&
                    parameters[parameter].name !== 'load_elevator' &&
                    parameters[parameter].name !== 'unload_elevator' &&
                    this._checkValue(parameters[parameter])) {
                    checkParameters = true;
                    break;
                }
            }

            this.setState({
                confirmedParameters: checkParameters
            })
        } else {
            this.setState({
                confirmedParameters: false
            })
        }
    }

    _checkLocations = () => {
        if (this.state.locations) {
            if (this.state.locations.from[0] && this.state.locations.to[0]) {
                if (this.state.locations.from[0].text && this.state.locations.to[0].text) {
                    this.setState({
                        confirmedLocations: true
                    })
                } else {
                    this.setState({
                        confirmedLocations: false
                    })
                }
            } else {
                this.setState({
                    confirmedLocations: false
                })
            }
        } else {
            this.setState({
                confirmedLocations: false
            })
        }
    }

    _checkDateAndTime = () => {
        if (this.state.dates.opened && this.state.dates.from && this.state.dates.to) {
            this.setState({
                confirmedDateAndTime: true
            })
        } else {
            this.setState({
                confirmedDateAndTime: false
            })
        }
    }

    _onLinkClick = (link, category) => {
        if (link === `/category/${category}`) {
            ga.event({
                category: 'clicks',
                action: 'add_size_cargo_bar',
                label: category,
                value: 1,
            });
        }

        ActionCreators.setStage(link, location.query);
    }

    render() {
        var category = this.state.selectedCategory.name;
        var { className, onChange, linkActive, ...props } = this.props;
        var progressBarPaneWrapperClass = classNames('ProgressBarPane-wrapper', className);
        var dimensionsTip = (
            <span>Вы можете <a onClick={this._onLinkClick.bind(this, `/category/${category}`, category)}>уточнить габариты груза</a> и&nbsp;перевозчики смогут точно оценить перевозку</span>
        );

        var progressBarPane = (
            <div>
                <div className="ProgressBarPane">
                    <ProgressBar
                        icon="box"
                        description="Описание груза"
                        sale="+10%"
                        tip="Вы можете поочередно добавить несколько грузов"
                        tipShow={!this.state.confirmedDescription && !linkActive[0] && this.state.showTips.tip1.value}
                        tipNumber={1}
                        link={`/category/${category}`}
                        linkActive={linkActive[0]}
                        confirmed={this.state.confirmedDescription}
                        onChange={this._onChange.bind(this)} />
                    <ProgressBar
                        icon="size"
                        description="Габариты"
                        sale="+10%"
                        tip={dimensionsTip}
                        tipSize="m"
                        tipShow={!this.state.confirmedDimensions && linkActive[1] && this.state.showTips.tip2.value}
                        tipNumber={2}
                        link={`/category/${category}`}
                        linkActive={linkActive[1]}
                        confirmed={this.state.confirmedDimensions}
                        onChange={this._onChange.bind(this)} />
                    <ProgressBar
                        icon="geolocation"
                        description="Откуда → куда"
                        sale="+20%"
                        link={`/category/${category}/route`}
                        linkActive={linkActive[3]}
                        confirmed={this.state.confirmedLocations}
                        onChange={this._onChange.bind(this)} />
                    <ProgressBar
                        icon="tools"
                        description="Доп. информация"
                        sale="+15%"
                        link={`/category/${category}/params`}
                        linkActive={linkActive[2]}
                        confirmed={this.state.confirmedParameters}
                        onChange={this._onChange.bind(this)} />
                    <ProgressBar
                        icon="clock"
                        description="Дата и время"
                        sale="+17%"
                        link={`/category/${category}/route`}
                        linkActive={linkActive[4]}
                        confirmed={this.state.confirmedDateAndTime}
                        onChange={this._onChange.bind(this)} />
                </div>
                <div className="ProgressBarPane-description">
                    Ваша потенциальная экономия может составить — 72%<br />
                    Чем подробнее вы заполните заявку, тем точнее мы будем подбирать для вас перевозчиков.
                </div>
            </div>
        );
        if (category === 'vehicle' ||
            category === 'people' ||
            category === 'animals' ||
            this.state.showInstantBooking) {
            progressBarPane = '';
        }

        return (
            <div className={progressBarPaneWrapperClass}>
                {progressBarPane}
            </div>
        );
    }
}

export default ProgressBarPane;



// WEBPACK FOOTER //
// ./client/components/ProgressBarPane/ProgressBarPane.js